import React from "react";

/**
 * Global radio / checkbox control — the single source of truth for the marker
 * shape so every selector in the app renders at ONE size and ONE corner radius
 * (no more per-call-site border-radius drift). Same idea as <Loader>.
 *
 * The visual lives in `.hopn-radio` (assets/css/styles.scss): a rounded square
 * that fills with an inner rounded square when checked. Change the shape THERE,
 * once, and every call site in both portals follows — do NOT hand-roll the
 * `appearance-none w-5 h-5 rounded-sm after:...` Tailwind string again.
 *
 * `type` is the only thing meant to vary per call site — "radio" for one-of-many,
 * "checkbox" for independent toggles (the marker looks the same either way).
 * Everything else (checked / onChange / name / value / disabled / aria-*) passes
 * straight through to the input.
 */
export function RadioButton({type = "radio", className = "", ...rest}) {
    return <input type={type} className={`hopn-radio${className ? ` ${className}` : ""}`} {...rest}/>;
}

export default RadioButton;
